import { cn } from "@acme/utils";
import type * as React from "react";

import {
  CardTitle as BaseCardTitle,
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
} from "@/components/base-ui/card";

function CardTitle({
  className,
  ...props
}: React.ComponentProps<typeof BaseCardTitle>) {
  return (
    <BaseCardTitle
      className={cn("font-display text-base tracking-[-0.005em]", className)}
      {...props}
    />
  );
}

export {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
};
